import apiClient from './index'
import type { Category, CategoryCreate, CategoryUpdate } from '@/types'
import type { ListQueryParams } from './types'

const BASE_URL = '/ssp/categories'

export const categoriesApi = {
  getAll: (params?: ListQueryParams) => apiClient.get<Category[]>(BASE_URL, { params })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch categories:', error)
      throw error
    }),
  getById: (id: number) => apiClient.get<Category>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to fetch category:', error)
      throw error
    }),
  create: (data: CategoryCreate) => apiClient.post<Category>(BASE_URL, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to create category:', error)
      throw error
    }),
  update: (id: number, data: CategoryUpdate) => apiClient.put<Category>(`${BASE_URL}/${id}`, data)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to update category:', error)
      throw error
    }),
  delete: (id: number) => apiClient.delete<Category>(`${BASE_URL}/${id}`)
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to delete category:', error)
      throw error
    }),
  exportExcel: () => apiClient.get(`${BASE_URL}/export`, { responseType: 'blob' })
    .then(res => res.data)
    .catch(error => {
      console.error('Failed to export categories to Excel:', error)
      throw error
    }),
  importExcel: (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post<{ created: number, updated: number, errors: number }>(`${BASE_URL}/import`, formData)
      .then(res => res.data)
      .catch(error => {
        console.error('Failed to import categories from Excel:', error)
        throw error
      })
  }
}
